import { useAppSelector } from '@redux/hooks';
import { Region } from '@enums/RegionList';
import { LinkColors, MyLink } from '@app/shared';

import styles from './InformationUniversal.module.scss';

const urlForRegion = {
  [Region.Hab]: '/actions/garantiya-luchshey-tsenyi/',
  [Region.RostovOnDon]: '/actions/garantiya-luchshey-tsenyi-rostov/',
  [Region.Krsk]: '/actions/garantiya-luchshey-tsenyi-krasnoyarsk/',
  [Region.Volgograd]: '/actions/garantiya-luchshey-tsenyi-volgograd/',
};

const InformationUniversal = () => {
  const { REGION: regionId } = useAppSelector(state => state.header.data.region);
  if ([Region.Hab, Region.Krsk, Region.RostovOnDon, Region.Volgograd].includes(parseInt(regionId))) {
    return (
      <div className={styles.Wrapper}>
        <div className={styles.Container}>
          Нашли дешевле? Сделаем скидку специально для вас!{' '}
          <MyLink href={urlForRegion[parseInt(regionId)]} color={LinkColors.Black}>
            Подробнее
          </MyLink>
        </div>
      </div>
    );
  } else {
    return null;
  }
};

export default InformationUniversal;
